export enum EPrimitiveType {
  String = 'string',
}

export const RegExPatterns = {
  Url: /^(https?|ftp):\/\/\w+(\.\w+)*(:\d+)?\/?(\/[.\w]*)*$/,
  Email: /^[\w\-.]+@([\w-]+\.)+[\w-]{2,}$/,
  AlphaNumeric: /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/,
  AlphaNumericUnderscore: /^[A-Za-z0-9]+(_[A-Za-z0-9]+)*$/,
  AplhaNumericHyphenUnderscore: /^[A-Za-z0-9]+(([-_])[A-Za-z0-9]+)*$/,
  AlphaNumericSeperators: /^[A-Za-z0-9]+(([-_:])[A-Za-z0-9]+)*$/,
  LanguageCode: /^[a-zA-Z]{2}-[a-zA-Z]{2}$/,
  MarketCode: /^[a-zA-Z]{2}$/,
  // UserName: /^((\([A-Za-z\s]+\)+(\s+))|([A-Za-z0-9]+(,\s|\s))|[A-Za-z0-9])+[A-Za-z0-9]+((,\s[A-Za-z0-9])|(\s(\([A-Za-z\s]+\))))?$/
};
